module.exports = __webpack_public_path__ + "img/en-mb-s6.2e46ea37.png";